import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export function RadarBackground() {
  const reduce = useReducedMotion();
  return <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 sm:h-[760px] sm:w-[760px]" aria-hidden="true" data-id="element-102" data-mp="20t2p0wmuypwi">
      <svg viewBox="0 0 700 700" fill="none" className="h-full w-full" data-id="element-103" data-mp="1rva7rmxkt86h">
        {[320, 240, 160, 80].map((r, i) => <motion.circle key={r} cx="350" cy="350" r={r} stroke="#c9a84c" strokeWidth={r === 80 ? 0.8 : 0.5} initial={{
        opacity: 0.1
      }} animate={reduce ? {
        opacity: 0.14
      } : {
        opacity: [0.08, 0.2, 0.08]
      }} transition={reduce ? undefined : {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut",
        delay: i * 0.5
      }} data-id="element-104" data-mp="2om2ommsc349b" data-mpi={i} />)}
        <g stroke="#c9a84c" opacity="0.14" data-id="element-105" data-mp="32j7scg4krr1e">
          <line x1="350" y1="30" x2="350" y2="670" strokeWidth="0.4" data-id="element-106" data-mp="32i6clycm6gdc" />
          <line x1="30" y1="350" x2="670" y2="350" strokeWidth="0.4" data-id="element-107" data-mp="3d7nqsm24x6l2" />
          <line x1="124" y1="124" x2="576" y2="576" strokeWidth="0.3" data-id="element-108" data-mp="3i5fuseg20j5m" />
          <line x1="576" y1="124" x2="124" y2="576" strokeWidth="0.3" data-id="element-109" data-mp="3i7s7ac31m1ba" />
        </g>
        <motion.line x1="350" y1="350" x2="350" y2="30" stroke="#c9a84c" strokeWidth="1" opacity="0.35" style={{
        transformOrigin: "350px 350px"
      }} animate={reduce ? undefined : {
        rotate: 360
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: "linear"
      }} data-id="element-110" data-mp="33g9uen5hcmw5" />
        <circle cx="460" cy="220" r="6" fill="#c9a84c" opacity="0.8" data-id="element-111" data-mp="2kiqmxnyo7cbu" />
        <circle cx="460" cy="220" r="14" stroke="#c9a84c" strokeWidth="1" opacity="0.3" data-id="element-112" data-mp="2ph1rbj674umo" />
        <circle cx="280" cy="180" r="4" fill="#c9a84c" opacity="0.5" data-id="element-113" data-mp="iqkjgl7wdl8q" />
        <circle cx="500" cy="400" r="5" fill="#c9a84c" opacity="0.6" data-id="element-114" data-mp="irdguvkyuye7" />
        <circle cx="350" cy="350" r="8" fill="#c9a84c" opacity="0.9" data-id="element-115" data-mp="nom3b8d5dol9" />
      </svg>
    </div>;
}